import { Breadcrumb } from "client/CommonComponents"
import { CONSTANTS } from "client/utils/constants"
import { GetStatusIcon } from "client/utils/IconsUtil";
import { useCallback } from "react";

interface IProps {
    breadcrumlist?:any,
    onClickBack?:any,
    savedStatus?:any,
    orderDetails?:any,
    bulkOrderHeaderDetails:any,
    isBulkOrder:any
}
const PurchaseOrderBreadcrumb = ({breadcrumlist,onClickBack,savedStatus,orderDetails,bulkOrderHeaderDetails, isBulkOrder }:IProps) => {
    const iconReturn = (status: any) => {
        return <img src={GetStatusIcon(status).icon} alt="statusIcon" className="statusIcon" />;
    };
    
    const getOrderStatus = useCallback((valType: any) => {
        if (isBulkOrder) {
            if (valType == "icon") {
                return iconReturn(bulkOrderHeaderDetails?.orderStatus)
            } else {
                return bulkOrderHeaderDetails?.orderStatus
            }
        } else {
            let val = savedStatus?.filter((savedItem?: any) => savedItem?.orderStatus == CONSTANTS?.ORDER_STATUS?.COMPLETED)
            if (savedStatus?.length) {
                if (val?.length) {
                    if (valType == "icon") {
                        return iconReturn(CONSTANTS?.ORDER_STATUS?.COMPLETED)
                    } else {
                        return CONSTANTS?.ORDER_STATUS?.COMPLETED
                    }
                } else {
                    if (valType == "icon") {
                        return iconReturn(savedStatus[0]?.orderStatus)
                    } else {
                        return savedStatus[0]?.orderStatus
                    }
                }
            } else {
                if (valType == "icon") {
                    return iconReturn(orderDetails?.orderStatus)
                } else {
                    return (orderDetails?.orderStatus)
                }
            }
        }
    }, [orderDetails, savedStatus, bulkOrderHeaderDetails])

    return(
    <div className="clearfix breadCrumbBlock mb-2">
            {
              <div className='backButton mb-sm-2 mb-3' onClick={onClickBack}>
                <span className="fa fa-chevron-left"></span>
                Back
              </div>
            }
            <div className="breadcrumbList">
              <Breadcrumb items={breadcrumlist} maxDisplayedItems="5"  data-attribute="PurchaseOrderBreadcrumb_Default_Breadcrumb" />
            </div>
        <div className="float-right">
          <div className="pending">
            <span>{getOrderStatus("icon")}</span>
            <span className="pending-approval-text">{getOrderStatus("label")}</span>
          </div>
        </div>
    </div> 
    )
}

export default PurchaseOrderBreadcrumb